import { unref, ref } from 'vue';
import normalize from '../../utils/normalize';

export default function usePhotoData({ type = '', photo = {} }) {
  const name = unref(photo) || '';
  return {
    photoName: ref(type === 'brand' ? normalize(name) : name),
  };
}
